export default "__VITE_ASSET__DckVWOBH__"